export const EMPLOYER_BUILDLIST_REQUEST = "EMPLOYER_BUILDLIST_REQUEST";
export const EMPLOYER_BUILDLIST_SUCCESS = "EMPLOYER_BUILDLIST_SUCCESS";
export const EMPLOYER_BUILDLIST_FAIL = "EMPLOYER_BUILDLIST_FAIL";

export const EMPLOYER_ALLBUILDLIST_REQUEST = "EMPLOYER_ALLBUILDLIST_REQUEST";
export const EMPLOYER_ALLBUILDLIST_SUCCESS = "EMPLOYER_ALLBUILDLIST_SUCCESS";
export const EMPLOYER_ALLBUILDLIST_FAIL = "EMPLOYER_ALLBUILDLIST_FAIL";

export const EMPLOYER_BUILDDETAIL_REQUEST = "EMPLOYER_BUILDDETAIL_REQUEST";
export const EMPLOYER_BUILDDETAIL_SUCCESS = "EMPLOYER_BUILDDETAIL_SUCCESS";
export const EMPLOYER_BUILDDETAIL_FAIL = "EMPLOYER_BUILDDETAIL_FAIL";

export const EMPLOYER_BUILDUPDATE_REQUEST = "EMPLOYER_BUILDUPDATE_REQUEST";
export const EMPLOYER_BUILDUPDATE_SUCCESS = "EMPLOYER_BUILDUPDATE_SUCCESS";
export const EMPLOYER_BUILDUPDATE_FAIL = "EMPLOYER_BUILDUPDATE_FAIL";

export const EMPLOYER_BUILD_REQUEST = "EMPLOYER_BUILD_REQUEST";
export const EMPLOYER_BUILD_SUCCESS = "EMPLOYER_BUILD_SUCCESS";
export const EMPLOYER_BUILD_FAIL = "EMPLOYER_BUILD_FAIL";
export const EMPLOYER_BUILD_RESET = "EMPLOYER_BUILD_RESET";

export const EMPLOYER_HIRELIST_REQUEST = "EMPLOYER_HIRELIST_REQUEST";
export const EMPLOYER_HIRELIST_SUCCESS = "EMPLOYER_HIRELIST_SUCCESS";
export const EMPLOYER_HIRELIST_FAIL = "EMPLOYER_HIRELIST_FAIL";

export const EMPLOYER_ALLHIRELIST_REQUEST = "EMPLOYER_ALLHIRELIST_REQUEST";
export const EMPLOYER_ALLHIRELIST_SUCCESS = "EMPLOYER_ALLHIRELIST_SUCCESS";
export const EMPLOYER_ALLHIRELIST_FAIL = "EMPLOYER_ALLHIRELIST_FAIL";

export const EMPLOYER_HIRE_REQUEST = "EMPLOYER_HIRE_REQUEST";
export const EMPLOYER_HIRE_SUCCESS = "EMPLOYER_HIRE_SUCCESS";
export const EMPLOYER_HIRE_FAIL = "EMPLOYER_HIRE_FAIL";
export const EMPLOYER_HIRE_RESET = "EMPLOYER_HIRE_RESET";
